/* eslint-disable */
export default {
  _appear_pop: 'appear_pop',
  _cherry_fall: 'cherry_fall',
  _cherry_land: 'cherry_land',
  _Chomp_1: 'Chomp_1',
  _Chomp_2: 'Chomp_2',
  _Chomp_3: 'Chomp_3',
  _click: 'click',
  _Eat_2: 'Eat-2',
  _Jingle_01: 'Jingle_01',
  _KEY_Remove_Cut_Key_mono: 'KEY_Remove_Cut_Key_mono',
  _menu_1: 'menu_1',
  _menu_2: 'menu_2',
  _save_print_startOver: 'save-print-startOver',
  _slide_long: 'slide_long',
  _slide_whistle_down: 'slide_whistle_down',
  _slide: 'slide',
  _SPRAY_CAN_Spray_Loop_02_loop_mono: 'SPRAY_CAN_Spray_Loop_02_loop_mono',
  _sprinkle1: 'sprinkle1',
  _sprinkle2: 'sprinkle2',
  _sprinkle3: 'sprinkle3',
  _TAP_Kitchen_Water_Tap_Drain_mono: 'TAP_Kitchen_Water_Tap_Drain_mono',
  _throw: 'throw',
  _topping_land: 'topping_land',
}